import React from 'react';
import styles from './IndexPage.module.css';
import BACKGROUNDIMAGE from '../../../static/images/vase.png';
import BellyMenu from "../../Inflatables/BellyMenu/BellyMenu";
import Header from "../../Inflatables/Header/Header";
import Footer from "../../Inflatables/Footer/Footer";
import PhotoSlider from "../../Inflatables/PhotoSlider/PhotoSlider";
import VerticalSpacer from "../../Inflatables/VerticalSpacer/VerticalSpacer";
import Modal from "../../Inflatables/Modal/Modal";

class IndexPage extends React.Component {

	state = {
		modal: false
	};

	setModal = (mode) => {
		this.setState({modal: mode});
	};

	render() {
		return (
			<div className={styles.indexPage}>
				<Modal open={this.state.modal} close={this.setModal}/>
				<BellyMenu page={"Home"} modal={this.setModal}/>
				<VerticalSpacer height={200}/>
				<Header modal={this.setModal}/>
				<VerticalSpacer height={100}/>
				<PhotoSlider modal={this.setModal}/>
				<VerticalSpacer height={150}/>
				<Footer/>
				<VerticalSpacer height={100}/>
				<img className={styles.vase} src={BACKGROUNDIMAGE} alt=""/>
			</div>
		);
	}

}

export default IndexPage;